var map = {
	"./asset.json": "./src/i18n/zh-cn/asset.json",
	"./default.json": "./src/i18n/zh-cn/default.json",
	"./discovery.json": "./src/i18n/zh-cn/discovery.json",
	"./login.json": "./src/i18n/zh-cn/login.json",
	"./menu.json": "./src/i18n/zh-cn/menu.json",
	"./option.json": "./src/i18n/zh-cn/option.json",
	"./quotation.json": "./src/i18n/zh-cn/quotation.json",
	"./quote.json": "./src/i18n/zh-cn/quote.json",
	"./settings.json": "./src/i18n/zh-cn/settings.json",
	"./trade.json": "./src/i18n/zh-cn/trade.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/i18n/zh-cn sync \\.json$";